import { useState } from 'react'
import '../styles/dynamism.scss'
//import Menu from './Menu'
//import WaveStroke from './icons/WaveStroke'
//import Video from './Video'
//import FirstTextSection from './FirstTextSection'
import ScrollyOne from './ScrollyOne'
import ScrollyTwo from './ScrollyTwo'
import ScrollyThree from './ScrollyThree'
//import SecondTextSection from './SecondTextSection'
//import BottomSection from './BottomSection'

const Dynamism = () => {
  //const scrollToTop = useRef(null)
  // const scrollToJobs = useRef(null)
  // const scrollToOpportunity = useRef(null)
  // const scrollToWages = useRef(null)
  // const scrollToSolutions = useRef(null)
  //const [isOpen, setIsOpen] = useState(false)
  const [activeSection] = useState(0)
  const [clicked] = useState(false)

  // const handleMenu = () => {
  //   setIsOpen(!isOpen)
  // }

  // const handleScroll = (section) => {
  //   switch (section) {
  //     case 'top':
  //       window.scrollTo(0, scrollToTop.current.offsetTop)
  //       setActiveSection(0)
  //       break
  //     case 'jobs':
  //       window.scrollTo(0, scrollToJobs.current.offsetTop)
  //       setActiveSection(1)
  //       break
  //     case 'opportunity':
  //       window.scrollTo(0, scrollToOpportunity.current.offsetTop)
  //       setActiveSection(2)
  //       break
  //     case 'wages':
  //       window.scrollTo(0, scrollToWages.current.offsetTop)
  //       setActiveSection(3)
  //       break
  //     case 'solutions':
  //       window.scrollTo(0, scrollToSolutions.current.offsetTop)
  //       setActiveSection(4)
  //       break
  //     default:
  //       window.scrollTo(0, scrollToTop.current.offsetTop)
  //   }
  //   setIsOpen(false)
  //   setClicked(!clicked)
  // }

  return (
    <div className="dynamism-body">
      {/* <Menu
        handleScroll={handleScroll}
        handleMenu={handleMenu}
        isOpen={isOpen}
      /> */}
      {/* <div className="dynamism-header"></div>
      <div className="dynamism-bar"></div> */}
      {/* <div className="video-bg">
        <div className="dynamism-content">
          <div className="dynamism-headline">the case for dynamism</div>
          <div className="section-header" ref={scrollToTop}>
            Securing opportunity for the American worker
          </div>
        </div>
        <WaveStroke />
        <div className="dynamism-content">
          <div className="dynamism-content-narrow">
            <div className="section-subhead">
              Economic dynamism refers to the underlying foment of change in an
              economy across industries, geographies, and the labor market. High
              levels of dynamism reflect a capacity for adaptation and renewal
              that allows a nation to thrive.
            </div>
          </div>
          <Video embedId={'WAZG2lJudd4'} />
        </div>
      </div>

      <FirstTextSection /> */}
      {/* <div className="scrolly-section-bg"> */}
      <div className="dynamism-content">
        <div className="section-header">
          Why is dynamism so important to the well-being of American workers?
        </div>
        {/* <div ref={scrollToJobs}> */}
        <ScrollyOne section={activeSection} clicked={clicked} />
        {/* </div> */}
        {/* <div ref={scrollToOpportunity}> */}
        <ScrollyTwo section={activeSection} clicked={clicked} />
        {/* </div> */}
        {/* <div ref={scrollToWages}> */}
        <ScrollyThree section={activeSection} clicked={clicked} />
        {/* </div> */}
      </div>
      {/* </div> */}
      {/* <div ref={scrollToSolutions}>
        <SecondTextSection />
      </div> */}
      {/* <div ref={scrollToSolutions}>
        <BottomSection />
      </div> */}

      {/* <div className="dynamism-footer-top" />
      <div className="dynamism-footer-bottom" /> */}
    </div>
  )
}

export default Dynamism
